/*=========================================================================================
	File Name: moduleAuthMutations.js
	Description: Auth Module Mutations
	----------------------------------------------------------------------------------------
	Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
	Author: Pixinvent
	Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from '../../http/axios/index.js'

export default {
	CUSTOMERACT_BALANCE(state, value) {
		state.CustomerActBalance = value;
	},
	CUSTOMERACT_ALL_LIST(state, value) {
		state.CustomerActAll = value;
	},
	CUSTOMERACT_LIST(state, value) {
		state.CustomerAct = value;
	},
	PAYMENT_LIST(state, value) {
		state.Payment = value;
	},
	SUPPLIER_ALL_LIST(state, value) {
		state.Supplier = value;
	},
	CUSTOMER_LIST(state, value) {
		state.Customer = value;
	}, CUSTOMER_INFO_LIST_FOR_CUSTOMER(state, value) {
		state.CustomerInfoListForCustomer = value
	},
	CUSTOMER_INFO_ALL_LIST(state, value) {
		state.CustomerInfoAllList = value
	}, CUSTOMER_INFO_LIST(state, value) {
		state.CustomerInfoList = value
	}, EMPLOYEE_LIST(state, value) {
		state.Employee = value
	}, EMPLOYEE_ALL_LIST(state, value) {
		state.EmployeeAll = value
	},
	ADD_ITEM_COMPANY(state, item) {
		const output = Object.entries(item).map(([key, value]) => [
			key[0].toUpperCase() + key.slice(1), value,]);
		state.Customer.push(Object.assign({}, Object.fromEntries(output)))
	},
	UPDATE_ITEM_COMPANY(state, item) {
		const output = Object.entries(item).map(([key, value]) => [
			key[0].toUpperCase() + key.slice(1), value,]);
		const outputCompany = Object.fromEntries(output)
		const index = state.Customer.findIndex(i => i.CompanyId === outputCompany.CompanyId)
		state.Customer[index] = outputCompany
	},
	DELETE_ITEM_COMPANY(state, item) {
		const index = state.Customer.findIndex(i => i.CompanyId === item)
		if (index > -1) { state.Customer.splice(index, 1) }
	}
}
